<div *transloco="let t">
  @if (showLicenseRatioCard) {
    <div
      class="rounded-xl border border-grey-lightGrey px-4 py-5 shadow-sm"
      animate.enter="ease-in-fast"
    >
      @if (type === 'basic') {
        <p class="text-sm font-semibold">
          {{ t('portal.subscription.licenses.licenseQuotaHeadline') }}
        </p>
      }
      @if (type === 'enrollment') {
        <p class="text-sm font-semibold">
          {{ enrollmentDescription }}
        </p>
      }

      <p class="mb-4 text-sm font-normal">
        {{
          t('portal.subscription.licenses.licenseQuotaDescription', {
            availableLicensesCount: availableLicensesCount(),
            totalLicensesCount: totalLicensesCount(),
          })
        }}
      </p>

      <app-sep-bar-chart [percentage]="availableToTotalLicensesRatio()" />
      @if (!freeTrial && !hideAddLicensesButton) {
        <div class="mt-4">
          <app-text-button (click)="addLicensesButtonClickEvent.emit()">{{
            t('portal.subscription.licenses.addLicensesButtonText')
          }}</app-text-button>
        </div>
      }
    </div>
  } @else {
    <app-info-card
      [headline]="
        t(
          'portal.courses.enrollment.licenses.numberOfAvailableLicensesExceededHeadline',
          { numberOfAvailableLicenses: totalLicensesCount() }
        )
      "
      [description]="
        t(
          'portal.courses.enrollment.licenses.numberOfAvailableLicensesExceededDescription'
        )
      "
    >
      @if (!freeTrial && !hideAddLicensesButton) {
        <app-text-button (click)="addLicensesButtonClickEvent.emit()">{{
          t('portal.courses.enrollment.licenses.addLicensesButtonText')
        }}</app-text-button>
      }
    </app-info-card>
  }
</div>
